import { AdditionalIcon } from "../components/shared/additionalIcon/additionalIcon";
import { KROFieldDict, KRTZFieldDict } from "../containers/centralView/shared/commentsSidebar/fieldDict";
import { CreateNewCommentDetails } from "../containers/centralView/shared/commentsSidebar/types/commentsSidebarProps";
import { LandslideRoadCategories, krFormTypes, KrEndangeredAreaFormTypes, KrLandslideFormTypes, NavHeadingsKROEnum, NavHeadingsKRTZEum, MonitoringRegisters } from "../contexts/krFormContext";
import { ObjectType, PatternType } from "../contexts/types/card";
import { ReactComponent as addCircleIcon } from '../icons/add_circle.svg';
import { GetOptions } from "./prepareForSelect";

export const prepareGminy = (value: string | null | undefined) => {
    // Position to add string
    let indexPosition = 2;

    // Using slice method to split string
    var newString = value?.slice(0, indexPosition)
        + '-' + value?.slice(indexPosition, 4) + '-' + value?.slice(4);

    return newString
}

const namesOfLandslideFields: string[][] = [
    ["sG_SZCZELINY", "Nie stwierdzono", "landslideAttributes"],
    ["zabezpieczeniE_OPIS", "Nie wykonano", "landslideAttributes"],
    ["sG_SKARPY_WTORNE", "Nie występują", "landslideAttributes"],
    ["szkodY_UPRAWY", "Nie stwierdzono", "landslideAttributes"],
    ["szkodY_INNE", "Nie stwierdzono", "landslideAttributes"],
    ["zagrozeniA_UPRAWY", "Nie występują", "landslideAttributes"],
    ["zagrozeniA_LINIE_PRZESYLOWE", "Nie występują", "landslideAttributes"],
    ["szkodY_LINIE_PRZESYLOWE", "Nie stwierdzono", "landslideAttributes"],
    ["zagrozeniA_ZABUDOWA", "Nie występują", "landslideAttributes"],
    ["zagrozeniA_KOMUNIKACJA", "Nie występują", "landslideAttributes"],
    ["zagrozeniA_INNE", "Nie występują", "landslideAttributes"],
    ["monitorinG_WSKAZ_WIZJI", "Brak wskazań", "landslideAttributes"],
    ["monitorinG_WSKAZ_MON", "Brak wskazań", "landslideAttributes"]
]

const namesOfEndangeredAreaFields: string[][] = [
    ["wskazania", "Obserwacje powinny być prowadzone nie rzadziej niż raz na 3 lata."]
]

export const prepareAllFields = (objectType: string, objectPattern: PatternType, krForm: krFormTypes) => {
    if (objectType === ObjectType.KRO) {
        prepareLandslideAllFields(krForm as KrLandslideFormTypes, objectPattern);
    } else if (objectType === ObjectType.KRTZ) {
        prepareEndangeredAreaAllFields(krForm as KrEndangeredAreaFormTypes);
    }
}

const prepareLandslideAllFields = (krForm: KrLandslideFormTypes, objectPattern: PatternType) => {
    if (krForm.landslideAttributes) {
        _setDefaultFields(namesOfLandslideFields, krForm.landslideAttributes);

        if (krForm.landslideAttributes.datA_USTALENIA) {
            krForm.landslideAttributes.datA_USTALENIA = krForm.landslideAttributes.datA_USTALENIA
                ? new Date(krForm.landslideAttributes.datA_USTALENIA).setHours(12, 0, 0, 0)
                : null
        }

        if (krForm.landslideAttributes.datA_WYPELNIENIA) {
            krForm.landslideAttributes.datA_WYPELNIENIA = krForm.landslideAttributes.datA_WYPELNIENIA
                ? new Date(krForm.landslideAttributes.datA_WYPELNIENIA).setHours(12, 0, 0, 0)
                : null
        }

        if ((!krForm.documents || krForm.documents.length === 0) && (!krForm.publications || krForm.publications.length === 0) &&
            !krForm.landslideAttributes.bibliografia) {
            krForm.landslideAttributes.bibliografia = "Brak informacji o prowadzonych badaniach osuwiska";
        }
        if ((krForm.documents && krForm.documents.length > 0) || (krForm.publications && krForm.publications.length > 0)) {
            krForm.landslideAttributes.bibliografia = "";
        }
        if (krForm.landslideBuildingDamages?.length === 0 && (krForm.landslideAttributes?.szkodY_ZABUDOWA_OPIS === "Nie stwierdzono"
            || !krForm.landslideAttributes?.szkodY_ZABUDOWA_OPIS)) {
            krForm.landslideAttributes.szkodY_ZABUDOWA_OPIS = "Nie stwierdzono";
        }
        if (krForm.landslideRoadDamages?.length === 0 && (krForm.landslideAttributes?.szkodY_KOMUNIKACJA_OPIS === "Nie stwierdzono"
            || !krForm.landslideAttributes?.szkodY_KOMUNIKACJA_OPIS)) {
            krForm.landslideAttributes.szkodY_KOMUNIKACJA_OPIS = "Nie stwierdzono";
        }

        if (krForm.roadCategories && krForm.roadCategories.length === 0) {
            var roadCategory: LandslideRoadCategories = {
                kategoriA_DROGI_SID: 0,
                osuwiskO_GID: krForm.landslideAttributes.globalid
            }
            krForm.roadCategories.push(roadCategory);
        }

        if (objectPattern === PatternType.P2020) {
            krForm.landslideAttributes.czY_MONITORING_POWIERZCHNIOWY = monitoringTypeCheck(1, krForm.landslideMonitoringRegisters);
            krForm.landslideAttributes.czY_MONITORING_WGLEBNY = monitoringTypeCheck(2, krForm.landslideMonitoringRegisters);
        } else if (objectPattern === PatternType.P2007) {
            let hasAnyMonitoring = krForm.landslideMonitoringRegisters && krForm.landslideMonitoringRegisters.length > 0;
            krForm.landslideAttributes.czY_MONITORING = hasAnyMonitoring ? 1 : 0;
        }
        krForm.landslideAttributes.czY_ZALACZNIK_MONITORINGU = krForm.landslideMonitoringAttachments && krForm.landslideMonitoringAttachments?.length > 0 ? 1 : 0;
        krForm.landslideAttributes.czY_WSKAZANIE_WIZJA = setFlag(krForm.landslideAttributes.monitorinG_WSKAZ_WIZJI, "brak wskazań");
        krForm.landslideAttributes.czY_WSKAZANIE_MONITORING = setFlag(krForm.landslideAttributes.monitorinG_WSKAZ_MON, "brak wskazań");
        krForm.landslideAttributes.czY_ZABEZPIECZONE = setFlag(krForm.landslideAttributes.zabezpieczeniE_OPIS, "nie wykonano");

        // Prepare building damages description
        if (!krForm.landslideAttributes.szkodY_ZABUDOWA_OPIS && krForm.landslideBuildingDamages?.length === 0) krForm.landslideAttributes.szkodY_ZABUDOWA = "";
        else {
            var buildingDamageDesc = "";
            if (krForm.landslideBuildingDamages && krForm.landslideBuildingDamages.length > 0) {
                const dictRodzajZabudowy = GetOptions("RODZAJ_ZABUDOWY", krForm.dictionaries, true);
                var addedBuildingTypes: number[] = [];

                krForm.landslideBuildingDamages
                    .sort((a, b) => dictRodzajZabudowy?.find(item =>
                        item.value === a.rodzaJ_ZABUDOWY_SID)?.anothers.KOLEJNOSC - dictRodzajZabudowy?.find(item => item.value === b.rodzaJ_ZABUDOWY_SID)?.anothers.KOLEJNOSC)
                    .forEach(damage => {
                        if (damage.rodzaJ_ZABUDOWY_SID && !addedBuildingTypes.includes(damage.rodzaJ_ZABUDOWY_SID)) {
                            if (buildingDamageDesc.length !== 0) buildingDamageDesc += "\n";

                            addedBuildingTypes.push(damage.rodzaJ_ZABUDOWY_SID);
                            var damagesForBuildingType = krForm.landslideBuildingDamages?.filter(item => item.rodzaJ_ZABUDOWY_SID === damage.rodzaJ_ZABUDOWY_SID);

                            var buildingTypeName = dictRodzajZabudowy?.find(item => item.value === damage.rodzaJ_ZABUDOWY_SID)?.name;
                            var damagedBuildingsNum = damagesForBuildingType!.find(item => item.rodzaJ_SZKODY_SID === 1)?.liczba;
                            var destroyedBuildingsNum = damagesForBuildingType!.find(item => item.rodzaJ_SZKODY_SID === 2)?.liczba;
                            buildingDamageDesc += `${buildingTypeName}: uszkodzone: ${damagedBuildingsNum ? damagedBuildingsNum : 0}, zniszczone: ${destroyedBuildingsNum ? destroyedBuildingsNum : 0}`
                        }
                    })
            }

            if (krForm.landslideAttributes.szkodY_ZABUDOWA_OPIS) {
                if (buildingDamageDesc.length !== 0) buildingDamageDesc += "\n";
                buildingDamageDesc += krForm.landslideAttributes.szkodY_ZABUDOWA_OPIS;
            }

            krForm.landslideAttributes.szkodY_ZABUDOWA = buildingDamageDesc;
        }

        // Prepare communication infrastructure damages description
        if (!krForm.landslideAttributes.szkodY_KOMUNIKACJA_OPIS && krForm.landslideRoadDamages?.length === 0) krForm.landslideAttributes.szkodY_KOMUNIKACJA = "";
        else {
            var roadDamageDesc = "";
            if (krForm.landslideRoadDamages && krForm.landslideRoadDamages.length > 0) {
                const dictCommInfra = GetOptions("INFRASTRUKTURA_KOMUNIKACYJNA", krForm.dictionaries, true);

                krForm.landslideRoadDamages
                    .sort((a, b) => dictCommInfra?.find(item =>
                        item.value === a.infrastrukturA_KOM_SID)?.anothers.KOLEJNOSC - dictCommInfra?.find(item => item.value === b.infrastrukturA_KOM_SID)?.anothers.KOLEJNOSC)
                    .forEach(damage => {
                        if (damage.infrastrukturA_KOM_SID) {
                            if (roadDamageDesc.length !== 0) roadDamageDesc += "\n";

                            var commInfraName = dictCommInfra?.find(item => item.value === damage.infrastrukturA_KOM_SID)?.name;
                            roadDamageDesc += `${commInfraName}: ${damage.dlugosc} m`
                        }
                    })
            }

            if (krForm.landslideAttributes.szkodY_KOMUNIKACJA_OPIS) {
                if (roadDamageDesc.length !== 0) roadDamageDesc += "\n";
                roadDamageDesc += krForm.landslideAttributes.szkodY_KOMUNIKACJA_OPIS;
            }

            krForm.landslideAttributes.szkodY_KOMUNIKACJA = roadDamageDesc;
        }
    }
    setLandslideRelTachnicalAttributes(krForm)
}

const setLandslideRelTachnicalAttributes = (krForm: KrLandslideFormTypes) => {
    setDevelopmentsRelTech(krForm);
}

export const setDevelopmentsRelTech = (krForm: KrLandslideFormTypes) => {
    if (krForm?.developments) {
        //extra update for kolejnosc, to keep consistance
        krForm.developments = krForm.developments
            .sort((a, b) => a.kolejnosc! - b.kolejnosc!)
            .map((d, index) => {
                return { ...d, kolejnosc: index }
            })

        if (krForm?.movementCause) {
            krForm.developments.forEach(item => {
                krForm.movementCause?.forEach(elem => {
                    if (item.globalid) {
                        if (elem.osuwiskO_ROZWOJ_GID === item.globalid) elem.idx = item.kolejnosc;
                    } else if (item.localUUID) {
                        if (elem.devId === item.localUUID) elem.idx = item.kolejnosc;
                    }
                });
            })
        }
    }
}

const setFlag = (value: any, defaultValue: string) => {
    return value && value.toLowerCase() !== defaultValue ? 1 : 0;
}

const prepareEndangeredAreaAllFields = (krForm: KrEndangeredAreaFormTypes) => {
    if (krForm.endangeredAreaAttributes) {
        _setDefaultFields(namesOfEndangeredAreaFields, krForm.endangeredAreaAttributes);
    }
    if (krForm.endangeredAreaAttributes?.datA_USTALENIA) {
        krForm.endangeredAreaAttributes.datA_USTALENIA = krForm.endangeredAreaAttributes.datA_USTALENIA
            ? new Date(krForm.endangeredAreaAttributes.datA_USTALENIA).setHours(12, 0, 0, 0)
            : null
    }

    if (krForm.endangeredAreaAttributes?.datA_WYPELNIENIA) {
        krForm.endangeredAreaAttributes.datA_WYPELNIENIA = krForm.endangeredAreaAttributes.datA_WYPELNIENIA
            ? new Date(krForm.endangeredAreaAttributes.datA_WYPELNIENIA).setHours(12, 0, 0, 0)
            : null
    }
}

const _setDefaultFields = (formFields: string[][], attributes: any) => {
    for (var i = 0; i < formFields.length; i++) {
        _setDefaultField(formFields[i], attributes);
    }
}

const _setDefaultField = (formField: string[], attributes: any) => {
    const item = attributes[formField[0]];
    if (item === null || item === "" || item === undefined) {
        attributes[formField[0]] = formField[1];
    }
}

export const monitoringTypeCheck = (type: number, monitoring?: MonitoringRegisters[]) => {
    let hasMonitoring = monitoring !== undefined && monitoring !== null && monitoring?.some(item => item.rodzaJ_MONITORINGU_SID === type || item.rodzaJ_MONITORINGU_SID === 3);
    return hasMonitoring ? 1 : 0;
}

export const getItemRef = (node: any, heading: NavHeadingsKROEnum | NavHeadingsKRTZEum, getMap: Function) => {
    if (getMap === undefined) return;
    const map = getMap();
    if (node) {
        map.set(`heading_${heading}`, node);
    } else {
        map.delete(`heading_${heading}`);
    }
}

export const getFieldRef = (node: any, field: KRTZFieldDict | KROFieldDict, getMap: Function) => {
    if (getMap === undefined) return;
    const map = getMap();
    if (node) {
        map.set(field, node);
    } else {
        map.delete(field);
    }
}

export const getFieldRefForRow = (node: any, field: KRTZFieldDict | KROFieldDict, rowGid: string, getMap: Function) => {
    var fieldName = getKRDictFieldNameForRow(field, rowGid);
    if (getMap === undefined) return;
    const map = getMap();
    if (node) {
        map.set(fieldName, node);
    } else {
        map.delete(fieldName);
    }
}

export const getKRDictFieldNameForRow = (field: KRTZFieldDict | KROFieldDict, rowGid: string) => {
    return `${field}_row_${rowGid}`;
}

export const checkIfMarkedForCommentFilter = (field: KRTZFieldDict | KROFieldDict, rowGid: string, markedField: string) => {
    return getKRDictFieldNameForRow(field, rowGid) === markedField;
}

export const getAddCommentBtnDetails = (editMode: boolean, fieldDictName: KRTZFieldDict | KROFieldDict, fieldFormName: string, setNewCommentFieldDetails: Function) => {
    return {
        visible: !editMode,
        onClick: (e: any) => {
            e.stopPropagation();
            var newCommentDetails: CreateNewCommentDetails = {
                visible: true,
                fieldDictName: fieldDictName,
                fieldFormName: fieldFormName
            }
            setNewCommentFieldDetails(newCommentDetails);
        }
    }
}

export const fireAddCommentBtnOnClickForRow = (fieldDictName: KRTZFieldDict | KROFieldDict, rowGid: string, fieldFormName: string, setNewCommentFieldDetails: Function) => {
    var fieldName = `${fieldDictName}_row_${rowGid}`
    var newCommentDetails: CreateNewCommentDetails = {
        visible: true,
        fieldDictName: fieldName,
        fieldFormName: fieldFormName
    }
    setNewCommentFieldDetails(newCommentDetails);
}

export const renderSectionCommentBtn = (markedForFiltering: boolean, editMode: boolean, title: string, setNewCommentFieldDetails: Function, fieldDict: KRTZFieldDict | KROFieldDict) => {
    return (
        <div style={{ height: "60px" }}>
            <div className={`addCommentBtnForSectionWrapper ${markedForFiltering ? "activeAddCommentBtn" : ""}`}
                onClick={getAddCommentBtnDetails(editMode!, fieldDict, title, setNewCommentFieldDetails).onClick}>
                {AdditionalIcon(addCircleIcon)}
            </div>
        </div>
    )
}

export const getClosestRefName = (elementRefs: any[], offset: number = 0) => {
    let closestName: string | null = null;
    let diff: number | null = null;
    elementRefs?.forEach((formRef: any) => {
        if (formRef) {
            for (const [name, value] of formRef) {
                let rect = value.getBoundingClientRect();
                let cDiff = Math.abs(rect.top - offset);
                if (diff === null) { diff = cDiff; }
                if (cDiff <= diff) {
                    closestName = name;
                    diff = cDiff;
                }
            }
        }

    });
    return closestName;
}

export const getClosestRefByName = (elementRefs: any[], name: string) => {
    for (const formRef of elementRefs) {
        if (formRef) {
            let item = formRef.get(name);
            if (item !== undefined) {
                return item;
            }
        }
    }
    return null;
}